import React from "react";

export const Backgroound = () => {
  return (
    <div className="mt-40">
      <div className="relative h-72 overflow-hidden bg-[#7E35FB] sm:px-20 rounded-3xl">
        <div className="z-10 flex h-full flex-col items-center justify-center space-y-4">
          <h1 className="text-center text-5xl font-bold text-white">
            A New Revolution Is Here
          </h1>
          <p className="text-lg text-white">
            The AI Calling Tool revolutionizes customer communication, offering
            seamless and intelligent interactions that improve engagement and
            efficiency.
          </p>
        </div>

        <div className="-z-1 absolute bottom-3 left-3 h-24 w-24 rounded-full bg-white bg-gradient-to-b from-white to-indigo-600 opacity-20"></div>
        <div className="-z-1 absolute -top-10 left-1/2 h-24 w-24 rounded-full bg-white bg-gradient-to-b from-white to-indigo-600 opacity-20"></div>

        <div className="-z-1 absolute top-20 right-10 h-16 w-16 rounded-full bg-white bg-gradient-to-b from-white to-indigo-600 opacity-25"></div>
        <div className="-z-1 absolute bottom-20 right-5 h-32 w-32 rounded-full bg-white bg-gradient-to-b from-white to-indigo-600 opacity-30"></div>
        <div className="-z-1 absolute top-12 left-20 h-20 w-20 rounded-full bg-white bg-gradient-to-b from-white to-indigo-600 opacity-15"></div>
        <div className="-z-1 absolute top-32 left-10 h-12 w-12 rounded-full bg-white bg-gradient-to-b from-white to-indigo-600 opacity-10"></div>
        <div className="-z-1 absolute bottom-28 left-1/4 h-28 w-28 rounded-full bg-white bg-gradient-to-b from-white to-indigo-600 opacity-20"></div>
      </div>
    </div>
  );
};
